import { Button } from "react-bootstrap";
import style from "./ImageUpload.module.css"
import { useTranslation } from "react-i18next";

export function ImageUpload({imageError, handleImage, imagePreview, imagePreviewCancel}) {
  const { t } = useTranslation();
  return (
    <>
      <div className={style.imageUploadWrapper}>
        <div className={style.imageUploadContainer}>
          {imagePreview ? (
            <div className="position-relative d-inline-block">
              <img src={imagePreview} alt="Preview" className={style.imagePreviewCircle} />
              <Button
                variant="danger"
                size="sm"
                className={style.removeImageBtn}
                onClick={() => {
                  imagePreviewCancel()
                }}
              >
                ×
              </Button>
            </div>
          ) : (
            <label className={style.uploadPlaceholder}>
              <input type="file" accept="image/*" onChange={handleImage} hidden />
              <div className="d-flex justify-content-center flex-column align-items-center">
                <span className="text-center small">{t('common.clickToUploadImage')}</span>
              </div>
            </label>
          )}
        </div>
        {imageError && <div className="text-danger small mt-2 text-start">{imageError}</div>}
      </div>
    </>
  );
}
